import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';

const ViewCompSubheQuery = () => {
    const navigate = useNavigate();
    const [queries, setQueries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        // Fetch Subhe Queries
        const queryRef = ref(db, 'ekamwatapzp/SubheQueries');
        const unsubscribe = onValue(queryRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data)
                    .map(key => ({
                        id: key,
                        ...data[key]
                    }))
                    .filter(q => q.status === 'Completed' || q.status === 'Approved' || q.status === 'Resolved'); // Assuming 'Completed' or similar status
                setQueries(list);
            } else {
                setQueries([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const filteredData = queries.filter(q =>
        q.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        q.mobileNo?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8f9fa] flex flex-col  p-8">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 px-2 text-[#344767]">
                    <h1 className="text-xl font-medium">सु.बे. कम्प्लीतेड क्वेरी यादी</h1>
                    <div className="flex items-center text-sm font-medium text-gray-400 gap-2">
                        <span>सांगली जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-500 font-semibold text-xs md:text-sm">सु.बे. कम्प्लीतेड क्वेरी यादी</span>
                    </div>
                </div>

                {/* Main Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 max-w-[100%]">

                    {/* Table Controls */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                        <div className="flex items-center rounded overflow-hidden shadow-sm border border-gray-300">
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Copy</button>
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Excel</button>
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium transition-colors">Print</button>
                        </div>

                        <div className="flex items-center gap-2 font-medium">
                            <label className="text-sm text-gray-600">Search:</label>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                            />
                        </div>
                    </div>

                    {/* Data Table */}
                    <div className="overflow-x-auto border border-gray-200 rounded text-[#344767]">
                        <table className="w-full text-left text-[14px] border-collapse bg-white">
                            <thead>
                                <tr className="bg-white border-b border-gray-200 font-bold divide-x divide-gray-100">
                                    <th className="px-4 py-4 w-12 text-center"># <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                    <th className="px-4 py-4 min-w-[150px]">Name <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                    <th className="px-4 py-4 min-w-[120px]">Mobile No. <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                    <th className="px-4 py-4 min-w-[200px]">Description <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                    <th className="px-4 py-4">File <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                    <th className="px-4 py-4">Status <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                    <th className="px-4 py-4 min-w-[150px]">Remark <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                    <th className="px-4 py-4 min-w-[150px]">Created At <span className="text-[10px] ml-1 text-gray-300">↑↓</span></th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {loading ? (
                                    <tr><td colSpan="8" className="text-center py-10 text-gray-400">Loading...</td></tr>
                                ) : filteredData.length > 0 ? (
                                    filteredData.map((q, index) => (
                                        <tr key={q.id} className="hover:bg-gray-50/50 transition-colors divide-x divide-gray-100">
                                            <td className="px-4 py-4 text-center font-medium">{index + 1}</td>
                                            <td className="px-4 py-4 font-bold">{q.name}</td>
                                            <td className="px-4 py-4">{q.mobileNo}</td>
                                            <td className="px-4 py-4 text-gray-600 truncate max-w-[200px]" title={q.description}>{q.description}</td>
                                            <td className="px-4 py-4">
                                                {q.fileUrl ? (
                                                    <a href={q.fileUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">View</a>
                                                ) : '-'}
                                            </td>
                                            <td className="px-4 py-4 font-bold text-gray-800">
                                                {q.status}
                                            </td>
                                            <td className="px-4 py-4 text-gray-600 truncate max-w-[150px]" title={q.remark}>{q.remark || '-'}</td>
                                            <td className="px-4 py-4 text-gray-500 font-medium">{q.createdAt}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="px-6 py-12 text-center text-gray-600 font-medium bg-gray-50/30">
                                            No data available in table
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Section */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mt-8 text-sm text-gray-600 font-medium">
                        <p>Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} entries</p>
                        <div className="flex rounded overflow-hidden border border-gray-300 bg-white">
                            <button className="px-4 py-2 hover:bg-gray-50 border-r border-gray-300 transition-colors text-gray-500 bg-white">Previous</button>
                            <button className="px-4 py-2 hover:bg-gray-50 transition-colors text-gray-500 bg-white">Next</button>
                        </div>
                    </div>

                </div>
            </div>
        </InchargeLayout>
    );
};

export default ViewCompSubheQuery;
